// Shared "marching dashes" line animation used by the Live Map mini-player
// (MiniReplayLayer) and the Route Replay multi-track map. Cycling the dash
// pattern shifts the offset so dashes appear to flow start -> end.
export const DASH_SEQ = [
  [0, 4, 3], [0.5, 4, 2.5], [1, 4, 2], [1.5, 4, 1.5], [2, 4, 1], [2.5, 4, 0.5],
  [3, 4, 0], [0, 0.5, 3, 3.5], [0, 1, 3, 3], [0, 1.5, 3, 2.5], [0, 2, 3, 2],
  [0, 2.5, 3, 1.5], [0, 3, 3, 1], [0, 3.5, 3, 0.5],
];

/**
 * Animate `line-dasharray` on a layer so its dashes flow forward.
 * Returns a cancel fn. Self-terminates if the layer disappears (leak backstop).
 */
export function animateLineDash(map, layerId) {
  let rafId = null;
  let step = 0;
  const tick = (ts) => {
    if (!map || map._removed || !map.getLayer(layerId)) { rafId = null; return; }
    const next = Math.floor((ts / 55) % DASH_SEQ.length);
    if (next !== step) {
      map.setPaintProperty(layerId, 'line-dasharray', DASH_SEQ[step]);
      step = next;
    }
    rafId = requestAnimationFrame(tick);
  };
  rafId = requestAnimationFrame(tick);
  return () => { if (rafId != null) { cancelAnimationFrame(rafId); rafId = null; } };
}
